import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

  constructor() { }

  public static noWhitespaceValidator(control: FormControl) {
		const isWhitespace = (control?.value || '').trim()?.length === 0;
		const isValid = !isWhitespace;
		return isValid ? null : { 'whitespace': true };
	}

	public static ConfirmedValidator(control: AbstractControl): ValidationErrors | null {
		const passWordcontrol = control.get('password');
		const confirmPasswordControl = control.get('confirmPassword');
		if (confirmPasswordControl?.errors && !confirmPasswordControl.errors['confirmedValidator']) {
			return null;
		}
		if (passWordcontrol?.value !== confirmPasswordControl?.value) {
			return ({ confirmedValidator: true });
		}
		return null;
	}

	public static phoneValidator(control: AbstractControl) {
		if(control?.value === null || control?.value === '') return null;
		const isValid = /^\d{10}$/.test(control?.value);
		return isValid ? null : { 'phone': true };
	}

	public static dateValidator(control: AbstractControl) {
		const isValid = /^\d{2}\/\d{2}\/\d{4}$/.test(control?.value);
		return isValid ? null : { 'date': true };
	}

	public static text(control: AbstractControl) {
		const isValid = /^[a-zA-Z ]*$/.test(control?.value);
		return isValid ? null : { 'text': true };
	}
}
